
        require('./index.scss');
        'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _formCheck = require('../home-toutiao/formCheck');

var _formCheck2 = _interopRequireDefault(_formCheck);

var _home = require('model/service/home');

var _home2 = _interopRequireDefault(_home);

var _cityIndex = require('model/service/cityIndex');

var _cityIndex2 = _interopRequireDefault(_cityIndex);

var _kftMd = require('assets/util/kft-md5');

var _kftMd2 = _interopRequireDefault(_kftMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;
var $mod = $('.module-decoration-cal');
var citySelect = require('component/cityselect');
var secretKey = 'd4c38977656e2356a6837e7b771bd408';

var _module = {
    calCheck: {},
    mobileChange: false,
    init: function init() {
        this.blockShowHide();
        this.cardshow();
        this.huxingChange();
        this.typeChange();
        this.claseClick();
        this.listener();
        citySelect($mod.find('.city-select'));
        this.formSubmit();
        this.placeHolder();
        this.initMobile();
        this.areaInput();
    },
    initMobile: function initMobile() {
        var domain = 'focus-test';
        var that = this;
        if (/(focus.*)\./.exec(window.location.href)) {
            domain = /(focus.*)\./.exec(window.location.href)[1];
        }
        $mod.find('.mobile-data-block').change(function (e) {
            if (e.target.value !== window.mobile) {
                that.mobileChange = true;
            } else {
                that.mobileChange = false;
            }
        });
        _cityIndex2['default'].getUserInfo(domain).then(function (res) {
            if (res.code === 200 && res.data) {
                console.log(res);
                window.mobile = res.data.mobile;
                $('.mobile-input-block').val(res.data.mobile);
                $('.mobile-input-block').removeClass('grey');
                $('.mobile-data-block').val(res.data.mobile);
                $('.mobile-data-block').removeClass('grey');
                $('.mobile-data-block').attr('data-mobile', res.data.mobile);
                $('.mobile-input-block').attr('data-mobile', res.data.mobile);
            }
        });
    },
    areaInput: function areaInput() {
        $('.form-container .area-data-block').on('input', function (_ref) {
            var target = _ref.target;

            $(target).val($(target).val().replace(/[^\d]/g, ''));
        });
    },
    blockShowHide: function blockShowHide() {
        $mod.find('.close').click(function () {
            $mod.hide();
        });
        $mod.click(function (e) {
            if ($(e.target).closest('.info-container').length <= 0) {
                $mod.hide();
            }
        });
    },
    placeHolder: function placeHolder() {
        $mod.find('.palceinfo').each(function (index, item) {
            $(item).addClass('grey').val($(this).data('placeholder'));
        });
        $mod.find('.palceinfo').focus(function () {
            if ($(this).val() == $(this).data('placeholder')) {
                $(this).val('').removeClass('grey');
            }
        }).blur(function () {
            if (!$(this).val()) {
                $(this).addClass('grey').val($(this).data('placeholder'));
            }
        });
    },
    cardshow: function cardshow() {
        var that = this;
        $mod.find('.has-card').click(function (e) {
            var $showHide = $(e.target).closest('.show-hide-block');
            if ($showHide.length >= 1) {
                return;
            }
            $mod.find('.show-hide-block').not($(this).find('.show-hide-block')).removeClass('show').prev().removeClass('open');
            $(this).find('.show-hide-block').toggleClass('show').prev().toggleClass('open');
            if ($(this).hasClass('huxing')) {
                that.huxingParse.call(that);
            }
        });

        $(window).click(function (e) {
            var $card = $(e.target).closest('.has-card');
            if ($card.length > 0) {
                return;
            }
            $mod.find('.show-hide-block').removeClass('show').prev().removeClass('open');
        });
    },
    huxingChange: function huxingChange() {
        $mod.find('.huxing').find('.bar-count').click(function () {
            $(this).addClass('active').siblings().removeClass('active');
        });
        $mod.find('.huxing').find('.button').click(function () {
            var lists = ['woshi', 'keting', 'chufang', 'weisheng', 'yangtai'];
            var listName = ['室', '厅', '厨', '卫', '阳台'];
            var strName = '';
            for (var i = 0; i < lists.length; i++) {
                var temp = $mod.find('.huxing').find('.' + lists[i] + '-line').find('.bar-count.active').data('count');
                $mod.find('.huxing').data(lists[i], temp);
                if (parseInt(temp, 10) > 0) {
                    strName = strName + temp + listName[i];
                }
            }
            $mod.find('.huxing').find('.text-info').text(strName);
            $mod.find('.huxing .show-hide-block').removeClass('show').prev().removeClass('open');
        });
    },
    huxingParse: function huxingParse() {
        var lists = ['woshi', 'keting', 'chufang', 'weisheng', 'yangtai'];
        for (var i = 0; i < lists.length; i++) {
            var temp = $mod.find('.huxing').data(lists[i]);
            $mod.find('.huxing').find('.' + lists[i] + '-line').find('.bar-count').removeClass('active').filter('[data-count="' + temp + '"]').addClass('active');
        }
    },
    typeChange: function typeChange() {
        $mod.find('.type .select-line').click(function () {
            var text = $(this).text();
            $mod.find('.type .text-info').text(text);
            $mod.find('.type .show-hide-block').removeClass('show').prev().removeClass('open');
        });
    },
    claseClick: function claseClick() {
        $mod.find('.clause .check').click(function () {
            $(this).toggleClass('active');
        });
    },
    listener: function listener() {
        Event.on('cal-block-show', function () {
            $mod.show();
        });
    },
    formSubmit: function formSubmit() {
        var _this = this;

        this.calCheck = new _formCheck2['default']($mod, [{
            name: 'city',
            container: '.form-container .city-select'
        }, {
            name: 'area',
            container: '.form-container .area-data-block'
        }, {
            name: 'mobile',
            container: '.form-container .mobile-data-block'
        }, {
            name: 'clause',
            container: '.form-container .clause-data-block'
        }]);

        $mod.find('.form-container .sub-button').click(function (e) {
            var res = _this.calCheck.check();
            console.log(res);
            // 电话改变，未验证
            if (_this.mobileChange && !window.captcha && res) {
                if (window.verify) {
                    var mobile = $mod.find('.mobile-data-block').val();
                    window.verify(mobile, $(e.target));
                }
            } else if (res) {
                res.roomPatternName = $mod.find('.form-container .huxing-data-block').text();
                res.roomPatternIpt = $mod.find('.form-container .huxing-data-block').text();
                res.isNewHouse = $mod.find('.form-container .type-data-block').text() == '新房装修' ? 1 : 0;
                var d = new Date();
                var data = {
                    adCode: res.areaCode,
                    name: res.area + '\u33A1-' + res.roomPatternName + '-' + (res.isNewHouse ? '新房装修' : '老房翻新'),
                    tel: res.mobile,
                    logDesc: 1,
                    eventTime: d.toISOString().slice(0, 10) + ' ' + /\d{2}:\d{2}:\d{2}/.exec(d)[0],
                    sign: (0, _kftMd2['default'])(res.mobile + secretKey),
                    captcha: window.captcha || ''
                };
                _home2['default'].postClue(data).then(function (result) {
                    if (result.code === 200) {
                        var obj = res.roomPatternName.match(/^(?<bedroomNum>\d)室((?<hallNum>\d)厅)?(?<kitchenNum>\d)厨(?<bathroomNum>\d)卫((?<balconyNum>\d)阳台)?$/);
                        var queryParams = obj ? (0, _keys2['default'])(obj.groups).map(function (k) {
                            return k + '=' + (obj.groups[k] || 0);
                        }).join('&') : 'bedroomNum=0&hallNum=0&kitchenNum=0&bathroomNum=0&balconyNum=0';
                        var temp = window.open();
                        temp.location = window.location.origin + '/decorationCost?houseArea=' + res.area + '&' + queryParams + '&isNewHouse=' + res.isNewHouse + '&areaCode=' + res.areaCode;
                        if (!window.mobile) setTimeout(function () {
                            return window.location.reload();
                        }, 200);
                        // Home.postCal(res).then((response)=> {
                        //     if (response.code === 0) {
                        //         var temp = window.open()
                        //         temp.location = 'https://home.focus.cn' + response.data.url;
                        //         if (!window.mobile) window.location.reload();
                        //     }
                        // })
                    } else {
                        window.toast && window.toast(result.msg || '提交失败，请稍后重试', 5000);
                    }
                    window.captcha = null;
                });
            }
        });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-index/decoration-cal/index.js